import { LogMessage } from '../types.js';

/**
 * set undefined or null values to empty strings
 * @param data data object
 * @returns cleaned data object
 */
const cleanupData = (data: Record<string, any>): Record<string, any> => {
  const cleanedData: Record<string, any> = {};
  Object.entries(data).forEach(([key, value]) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    cleanedData[key] = value === undefined || value === null ? '' : value;
  });
  return cleanedData;
};

export const logRocket = {
  error: (msg: LogMessage) => {
    if (!msg) return;
    const { message, ...rest } = msg ?? {};
    if (!message) return;
    window.emui?.logRocket?.captureMessage?.(message, {
      extra: rest as { [tagName: string]: string | number | boolean },
    });
  },
  audit: (msg: LogMessage) => {
    const {
      message,
      host,
      environment,
      appName,
      appVersion,
      team,
      location,
      correlationId,
      instanceId,
      customerId,
      userId,
      loanId,
      resourceType,
      resourceId,
    } = msg ?? {};
    window.emui?.logRocket?.track?.(
      message,
      cleanupData({
        host,
        environment,
        appName,
        appVersion,
        team,
        location,
        correlationId,
        instanceId,
        customerId,
        userId,
        loanId,
        resourceId,
        resourceType,
      }),
    );
  },
};
